import type { LegacyBrand } from './ResolveLegacyBrand.types';

const FROM_PARAM_MAP: Record<string, LegacyBrand> = {
  buyacar: 'buyacar',
  heycar: 'heycar',
  'heycar-uk': 'heycar',
  'heycar-de': 'heycar-de',
  heyde: 'heycar-de',
  'heycar-fr': 'heycar-fr',
  heyfr: 'heycar-fr',
  'heycar-es': 'heycar-es',
  heyes: 'heycar-es',
  hj: 'honestjohn',
};

export const resolveLegacyBrand = (from: string | null): LegacyBrand | null => {
  if (!from) return null;
  return FROM_PARAM_MAP[from.trim().toLowerCase()] ?? null;
};
